const state = {
  cedigroupEdit: null,
  cedigroupDelete: null
}

export default state